export interface JobApi {
	id: string;
	name: string;
	created_at: string;
	updated_at: string;
	finished_at: string;
	status: string;
	steps: JobStepApi[];
	settings: JobSettingApi[];
	error?: string;
}

export interface JobStepApi {
	id: string;
	name: string;
	created_at: string;
	finished_at: string;
	status: string;
	error: string;
	settings: JobSettingApi[];
}

export interface JobSettingApi {
	name: string;
	value: string;
}

export interface JobNameApi {
	id: string;
	title: string;
}

export enum JobsStatus {
	STARTED = "STARTED",
	FINISHED = "FINISHED",
}
